export const VERTEX_SPECIFIC_LINKS = {
  abstractDiscover: 'https://www.abs.xyz/discover',
  aerodomePool:
    'https://aerodrome.finance/deposit?token0=0x4200000000000000000000000000000000000006&token1=0xFB0c734Fc3008683c5efF45bcf8128836C4D97D0&type=-1',
  blitzApp: 'https://app.blitz.exchange',
  blitzTestnetApp: 'https://testnet.blitz.exchange',
  brotradeApp: 'https://app.bro.trade',
  fuulReferralsDocs:
    'https://docs.vertexprotocol.com/community-and-tokenomics/referral-program-new',
  rewardsDocs:
    'https://docs.vertexprotocol.com/community-and-tokenomics/trade-and-earn-rewards-program',
  sonicApp: 'https://www.soniclabs.com/',
  sonicGemsDocs:
    'https://docs.vertexprotocol.com/getting-started/vertex-edge/vertex-on-sonic/trading-rewards',
  sonicIncentivesDocs:
    'https://docs.vertexprotocol.com/getting-started/vertex-edge/vertex-on-sonic/trading-rewards',
  stakeVrtxDocs:
    'https://docs.vertexprotocol.com/community-and-tokenomics/the-vertex-lba/stake-vrtx',
  transporterBridge: 'https://app.transporter.io/?token=VRTX',
  vrtxExchanges: {
    bybit: 'https://www.bybit.com/en/trade/spot/VRTX/USDT',
    traderJoe:
      'https://lfj.gg/arbitrum/trade?outputCurrency=0x95146881b86b3ee99e63705ec87afe29fcc044d9',
    kucoin: 'https://www.kucoin.com/trade/VRTX-USDT',
    camelot:
      'https://info.camelot.exchange/pair/arbitrum-one/v3/0x3cf4cb6ce8cf3b147e6c444cf66526f5f0c16b92',
    mexc: 'https://www.mexc.com/exchange/VRTX_USDT',
    htx: 'https://www.htx.com/trade/vrtx_usdt',
  },
  vrtxExplorers: {
    arbiscan:
      'https://arbiscan.io/token/0x95146881b86b3ee99e63705ec87afe29fcc044d9',
    etherscan:
      'https://etherscan.io/token/0xbbEE07B3e8121227AfCFe1E2B82772246226128e',
    basescan:
      'https://basescan.org/address/0xFB0c734Fc3008683c5efF45bcf8128836C4D97D0',
    blastScan:
      'https://blastscan.io/address/0x6CD20f11470e9C9d1458a69c8f7B330B99577EF9',
  },
  vrtxInfo: {
    coinMarketCap: 'https://coinmarketcap.com/currencies/vertex-protocol/',
    coinGecko: 'https://www.coingecko.com/en/coins/vertex-2',
  },
  vrtxTradingCompetitionDocs:
    'https://docs.vertexprotocol.com/more/trading-competitions',
  wrapSei: 'https://dragonswap.app/swap',
  wrapSonic: 'https://app.magpiefi.xyz/swap/sonic/S/sonic/wS',
};

export const VERTEX_COMMON_LINKS = {
  appStatus: 'https://vertex.betteruptime.com',
  cookiePolicy: 'https://vertexprotocol.com/docs/CookiePolicy.pdf',
  crossChainDocs:
    'https://docs.vertexprotocol.com/tutorials/cross-chain-deposits',
  discord: 'https://discord.gg/vertexprotocol',
  docs: 'https://docs.vertexprotocol.com/getting-started/overview',
  faq: 'https://docs.vertexprotocol.com/basics/faqs',
  fastWithdrawalsLearnMore: `https://docs.vertexprotocol.com/tutorials/fast-withdrawals`,
  hacken: 'https://hackenproof.com/company/vertex-protocol/programs',
  isolatedDocs: 'https://docs.vertexprotocol.com/basics/isolated-margin',
  lpDocs: 'https://docs.vertexprotocol.com/basics/hybrid-orderbook-amm-design',
  maintenanceWindowDocs:
    'https://docs.vertexprotocol.com/more/maintenance-windows-and-status',
  marketingSite: 'https://vertexprotocol.com',
  multipleSubaccountsDocs:
    'https://docs.vertexprotocol.com/tutorials/multiple-accounts',
  privacyPolicy: 'https://vertexprotocol.com/docs/PrivacyPolicy.pdf',
  referralDocs:
    'https://docs.vertexprotocol.com/community-and-tokenomics/referrals',
  spotTradingLearnMore: 'https://docs.vertexprotocol.com/tutorials/spot',
  spreadDocs:
    'https://docs.vertexprotocol.com/basics/subaccounts-isolated-margin-and-health#special-cases-spreads-lps-and-large-positions',
  termsOfUse: 'https://vertexprotocol.com/docs/TermsOfUse.pdf',
  tutorials: 'https://docs.vertexprotocol.com/tutorials/quick-start',
  twitter: 'https://twitter.com/vertex_protocol',
};
